'use client';

import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface LinkButtonProps extends ComponentPropsWithoutRef<'button'> {
  children: ReactNode;
}

export const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button ref={ref} className={cn('neu-link overflow-hidden px-0', className)} {...props}>
        {children}
      </button>
    );
  }
);

LinkButton.displayName = 'LinkButton';
